'use client';
import { useEffect, Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { saveCookie } from '../lib/saveCookie';
import { payConfig } from '~/config/_pages/pay';

const QueryUpdater = () => {
  const searchParams = useSearchParams();
  
  useEffect(() => {
    payConfig.ref.traking_refs.forEach((param) => {
      const value = searchParams.get(param);
      if (value) {
        saveCookie(param, value);
      }
    });
  }, [searchParams]);
  
  return null;
};

export const QueryManager = () => {
  return (
    <Suspense fallback={null}>
      <QueryUpdater />
    </Suspense>
  );
};